var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 3L20.9992 10H11.0004L16.0002 3Z",
    fill: "#FFC44D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9992 10L6.00017 3L1.00037 10H10.9992Z",
    fill: "#FFC44D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9992 10L26.0002 3L21.0004 10H30.9992Z",
    fill: "#FFC44D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 10.0002L15.9999 31.0002L20.9999 10.0002H10.9999Z",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 31L1 10H11L16 31Z",
    fill: "#FFC44D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 31L20.9998 10H30.9998L16 31Z",
    fill: "#FFC44D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9994 10L6.00037 3H15.9992L10.9994 10Z",
    fill: "#FFE6EA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9993 9.99988L16.0004 3H25.9992L20.9993 9.99988L16 30.9999L10.9994 10L20.9993 9.99988Z",
    fill: "#FFE6EA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3L1 10M6 3H26M6 3L11 10M1 10L16 31M1 10H31M16 31L31 10M16 31L21 10M16 31L11 10M31 10L26 3M26 3L21 10M21 10L16 3L11 10",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge5);
export default __webpack_public_path__ + "static/media/badge5.5e11cb1d60f6b1bd2baa29305a85b664.svg";
export { ForwardRef as ReactComponent };